import { useCookies } from "react-cookie"

const useRoleCookie = () => {

    const cookieName = "RC1"
    const [cookie, setCookie, removeCookie] = useCookies([cookieName])

    const createCookie = (role) => {
        setCookie(cookieName, role, {
            "path": "/",
            "sameSite": "none",
            "secure": true,
            "expires": new Date(Date.now() + 1000 * 3600 * 24)
        })
    }

    const deleteCookie = () => {
        removeCookie(cookieName, { "path": "/" })
    }

    return [cookie[cookieName], createCookie, deleteCookie]
}

export default useRoleCookie